import { render, staticRenderFns } from "./standard-pageframe.vue?vue&type=template&id=9d9db990&scoped=true&"
import script from "./standard-pageframe.vue?vue&type=script&lang=js&"
export * from "./standard-pageframe.vue?vue&type=script&lang=js&"
import style0 from "./standard-pageframe.vue?vue&type=style&index=0&id=9d9db990&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9db990",
  null
  
)

export default component.exports